import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import loginimg from "../Assets/Img/loginsideimg.png";
import axiosMain from "../http/axiosMain";

function SignUpWithEmail() {
  const [email, setEmail] = useState(""); // To store the email
  const [loading, setLoading] = useState(false); // To show loading state
  const [serverError, setServerError] = useState(""); // To store server errors
  const navigate = useNavigate(); // To navigate to other pages
  const [role, setRole] = useState(""); // Store role (brand/influencer)

  // Retrieve role from localStorage when component mounts
  useEffect(() => {
    const storedRole = localStorage.getItem("userType") || ""; // Default to bran

    setRole(storedRole);
    console.log(storedRole);
  }, []);

  // Handle email change
  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); // Show loading spinner
    setServerError(""); // Reset any previous errors

    try {
      // Call the API to send OTP using Axios
      const response = await axiosMain.post("/api/auth/send-email-otp", {
        email,
        role, // Include role in the request
      });
      console.log(response);

      if (response.status === 200 && response.data.status!==false) {
        sessionStorage.setItem("email", email);
        // If OTP is sent successfully, redirect to OTP page
        navigate("/sign-email-otp/" + email); // Navigate to the OTP page
      } else {
        // Handle error response from the API
        setServerError(
          response.data.message || "An error occurred. Please try again."
        );
      }
    } catch (error) {
      // Handle network or unexpected errors
      setServerError("Failed to send OTP. Please try again later.");
    } finally {
      setLoading(false); // Reset loading state
    }
  };

  return (
    <div className="container-email p-0 mt-5 mb-5">
      <div className="card">
        <div className="row no-gutters">
          {/* Left Side (Image Section) */}
          <div className="col-xs-12 col-sm-12 col-md-6 left">
            <img src={loginimg} alt="sideimg" className="img" />
          </div>

          {/* Right Side (Login Section) */}
          <div className="col-xs-12 col-sm-12 col-md-6 right">
            <div className="row">
              <div className="col-12 text-center">
                <h2>
                  Collaborate.
                  <br /> Create. Connect.
                </h2>
                <form onSubmit={handleSubmit}>
                  {/* Email Input Field */}
                  <div className="inputForm">
                    <input
                      type="email"
                      name="email"
                      placeholder="Enter your Email"
                      className="input text-center"
                      value={email} // Bind the email value here
                      onChange={handleEmailChange} // Handle email input change
                      style={{ color: "rgba(107, 142, 118, 1)" }}
                      required
                    />
                  </div>

                  {/* Server Error Message */}
                  {serverError && <p className="error-text">{serverError}</p>}

                  {/* Remember Me Checkbox */}
                  <div className="flex-row d-flex justify-content-between align-items-center mt-3">
                    <div>
                      <input type="checkbox" />
                      <label className="ms-2">Remember me</label>
                    </div>
                  </div>

                  {/* Submit Button */}
                  <button
                    type="submit"
                    className="button-submit btn-outline-success"
                  >
                    {loading ? "Sending OTP..." : "SignUp With Email"}
                  </button>
                </form>
              </div>

              {/* Footer Links */}
              <div className="col-12 footer">
                <div className="sign-link mt-auto">
                  <Link
                    to="/phone"
                    className="btn-link btn-outline-success"
                  >
                    Login With Phone
                  </Link>
                </div>
                <div className="signup-instruction">
                  By continuing, you agree to our terms and conditions.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SignUpWithEmail;
